module.exports = __webpack_public_path__ + "static/media/rightIncrementArrow.2def3671.svg";